export default __webpack_public_path__ + "static/media/profile.a81b3bec.png";